import { RegistryItem } from "@schemas/calculationmethods/schema";
import { DemurrageSchema } from "@schemas/calculationmethods/demurrage.schema";
import { LumpsumSchema } from "@schemas/calculationmethods/lumpsum.schema";
import { PercentageOnAgreementsSchema } from "@schemas/calculationmethods/percentageOnAgreements.schema";
import { TimeUnitSchema } from "@schemas/calculationmethods/timeUnit.schema";
import { QuantityUnitSchema } from "@schemas/calculationmethods/quantityUnit.schema";
import { DemurrageCalculationSchema } from "@schemas/calculationmethods/demurrageCalculation.schema";
import { StaffelSchema } from "@schemas/calculationmethods/staffel.schema";
import { ReferenceRateSchema } from "@schemas/calculationmethods/referenceRate.schema";
import { ManualSchema } from "@schemas/calculationmethods/manual.schema";
import { CargoQuantitySchema } from "@schemas/calculationmethods/cargoQuantity.schema";
import { TieredSchema } from "@schemas/calculationmethods/tiered.schema";
import { GasoilConsumptionSchema } from "@schemas/calculationmethods/gasoilConsumption.schema";
import { CoveredByFreightPriceSchema } from "@schemas/calculationmethods/coveredByFreightPrice.schema";

const SchemaRegistry: RegistryItem[] = [
	LumpsumSchema,
	PercentageOnAgreementsSchema,
	TimeUnitSchema,
	QuantityUnitSchema,
	DemurrageSchema,
	DemurrageCalculationSchema,
	StaffelSchema,
	ReferenceRateSchema,
	ManualSchema,
	CargoQuantitySchema,
	TieredSchema,
	GasoilConsumptionSchema,
	CoveredByFreightPriceSchema,
];

export const CalculationMethodSchema: RegistryItem = Object.assign({} as RegistryItem, ...SchemaRegistry);
